<template>
  <div class="hrdcloud-list-wrapper hrdcloud-swiper" :class="{ 'hrdcloud-list-edit' : isEditable }">
    <slot name="action" />
    <swiper
        class="hrdcloud-list"
        :modules="modules"
        slides-per-view="auto"
        :coverflow-effect="{rotate:30, stretch:0, depth:100, modifier:1, slideShadows:false}"
        :centered-slides="false"
        @swiper="setControlledSwiper"
    >
      <swiper-slide v-for="(item,idx) in items" :key="idx" class="hrdcloud-item px-1" :class="{'isShorts' : isShorts}">
        <HrdCloudEasyContent
            v-if="item.cttTyCdDcd === cttTyCdDcds.CTT_TY_CD_ZIP"
            :item="item"
            :idx="idx"
            :session="session"
            :is-editable="isEditable"
            :is-selected="item.isSelected"
            :show-put="showPut"
            @click.stop="editFunc && editFunc(idx)"
        />
        <HrdCloudContent
            v-else
            :item="item"
            :idx="idx"
            :session="session"
            :is-editable="isEditable"
            :is-selected="item.isSelected"
            :show-put="showPut"
            :is-shorts="isShorts"
            @click.stop="editFunc && editFunc(idx)"
        />
      </swiper-slide>
      <swiper-slide v-if="swipeLoading" class="board-item" style="margin-top: 50px; width: 200px;">
        <LoadingDiv/>
      </swiper-slide>
    </swiper>
  </div>
</template>
<style scoped>
.isShorts {
  flex: 0 0 200px !important;
}
</style>
<script>
import HrdCloudContent from '@/components/hrdcloud/HrdCloudContent';
import HrdCloudEasyContent from '@/components/hrdcloud/HrdCloudEasyContent';
import {Pagination, EffectCoverflow} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/vue/swiper-vue';
import {cttTyCdDcds, disableMyAddChanged} from '@/assets/js/modules/hrd/hrd-common';
import {computed, ref, toRefs, watch} from 'vue';
import {useStore} from 'vuex';
import LoadingDiv from "@/components/common/LoadingDiv.vue";

export default {
  name: 'HrdCloudMobileSwiper',
  components: {LoadingDiv, Swiper, SwiperSlide, HrdCloudEasyContent, HrdCloudContent},
  props: {
    items: Array,
    session: Object,
    showPut: Boolean,
    isEditable: Boolean,
    editFunc: Function,
    isShorts: Boolean,
    addShortsItems: Function,
    swipeLoading: Boolean
  },
  setup(props) {
    const store = useStore();
    const leaderAdd = computed(() => store.state.hrdcloud.leaderAdd);
    const {items} = toRefs(props);

    const controlledSwiper = ref(null);
    const setControlledSwiper = (swiper) => {
      controlledSwiper.value = swiper;

      watch(() => controlledSwiper.value.isEnd, () => {
        if (controlledSwiper.value.isEnd === true && props.isShorts && !props.swipeLoading) {
          props.addShortsItems();
        }
      })
    };

    watch(() => leaderAdd.value.show, () => {
      if (!leaderAdd.value.show && leaderAdd.value.updateMyAdd) {
        const lrnObjDtlDistSn = leaderAdd.value.lrnObjDtlDistSn;
        const item = items.value && items.value.length > 0 ? items.value.filter(x => x.lrnObjDtlDistSn === lrnObjDtlDistSn)[0] : null;
        if (item) {
          item.put = leaderAdd.value.isPut;
          disableMyAddChanged();
        }

      }
    });

    return {
      cttTyCdDcds,
      modules: [Pagination, EffectCoverflow],
      setControlledSwiper
    }
  }
};
</script>